// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__WvvKk","row":"default_row__Q+nfu"};